import * as Sentry from '@sentry/browser';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Button from '../../components/Button';
import Input from '../../components/Input';
import Loader from '../../components/Loader';
import OtherContent from '../../components/OtherContent';
import Api from '../../services/api';
import { validateEmail, __ } from '../../utilities';
import { loadOtherContentById } from '../App/actions';
import {
  otherContentContentSelector,
  otherContentIsFetchingSelector,
  otherContentNameSelector,
} from '../App/selectors';
import { locale } from '../LocaleProvider';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 50.0625rem;
  margin: 0 auto;
`;

const ButtonLink = styled.a`
  text-decoration: none;
`;

const MainText = styled.div`
  font-size: ${rem(40)};
  color: ${({ theme }) => theme.color.font.primary};
  margin: ${rem(30)} 0;
  text-align: center;
`;

const SubText = styled.div`
  margin-bottom: ${rem(10)};
`;

const NotDeliveredMail = styled.div`
  margin-bottom: 0.625rem;
  margin-top: 4.5rem;
  width: 100%;
  max-width: ${rem(400)};
`;

const NewMain = styled.div`
  text-align: center;
`;

const Detail = styled.div`
  width: ${rem(400)};
  text-align: center;
`;

export const DetailTable = styled('div')`
  margin: 1rem 0;
  padding: 0 1rem;
  width: 100%;
  overflow: auto;
  font-size: ${rem(14)};
  table {
    border: 1px solid #333;
    border-collapse: collapse;
    th,
    td {
      border: 1px solid #333;
      padding: 0.5em;
    }
  }
`;

const WrapperMail = styled.div`
  display: flex;
  align-items: center;
`;

const NewMailText = styled.div`
  font-size: ${rem(20)};
  margin-bottom: 1.25rem;
`;

const StyledInput = styled(Input)`
  height: ${rem(46)};
  border: ${rem(1)} solid #ddd;
`;

const InputWrapper = styled.div`
  margin-right: ${rem(5)};
`;

class ThanksPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mail: '',
      mailIsSending: false,
      detailTable: null,
      detailTableIsFetching: false,
    };

    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleClickMailSend = this.handleClickMailSend.bind(this);
  }

  async componentDidMount() {
    const {
      dispatch,
      location: {
        query: { vs, pass },
      },
    } = this.props;
    dispatch(loadOtherContentById('RESERVATION_PAYMENT_OK'));
    try {
      this.setState({ detailTableIsFetching: true }); // eslint-disable-line react/no-did-mount-set-state
      const res = await Api.getReservationDetailTable(vs, pass);
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        detailTable: res.ticketsHtml,
        detailTableIsFetching: false,
      });
    } catch (e) {
      this.setState({ detailTableIsFetching: false }); // eslint-disable-line react/no-did-mount-set-state
    }
  }

  handleChangeInput(e) {
    const {
      target: { name, value },
    } = e;
    this.setState({
      [name]: value,
    });
  }

  handleClickMailSend() {
    if (this.state.mail !== '') {
      if (validateEmail(this.state.mail)) {
        const {
          location: {
            query: { vs, pass },
          },
        } = this.props;
        this.setState({ mailIsSending: true });
        Api.repeatMail(vs, pass, this.state.mail)
          .then(() => {
            this.setState({ mailIsSending: false });
            alert(__('Na Vami zadaný mail bol odoslaný mail.'));
          })
          .catch(e => {
            Sentry.captureException(e);
            this.setState({ mailIsSending: false });
            alert(
              __('Požiadavku na opätovné zaslanie mailu nebolo možné odoslať.'),
            );
          });
      } else {
        alert(__('Zadajte platný mail.'));
      }
    } else {
      alert(__('Zadajte mail.'));
    }
  }

  renderDetailTable = () => {
    const { detailTable, detailTableIsFetching } = this.state;
    if (detailTableIsFetching) {
      return <Loader size="l" text={__('Načítavam detail rezervácie')} />;
    }
    if (!detailTableIsFetching && !detailTable) {
      return __('Nepodarilo sa načítať detail rezervácie');
    }
    return <DetailTable dangerouslySetInnerHTML={{ __html: detailTable }} />;
  };

  render() {
    const {
      location: {
        query: { vs, pass },
      },
      otherContentIsFetching,
      otherContentName,
      otherContent,
    } = this.props;
    const { mailIsSending } = this.state;

    if (otherContentIsFetching) {
      return <Loader size="xl" />;
    }

    return (
      <Wrapper>
        <MainText>{otherContentName}</MainText>
        <Detail>
          <SubText>
            <OtherContent content={otherContent} />
          </SubText>
          {vs && pass && (
            <ButtonLink
              target="_blank"
              href={`${
                process.env.REACT_APP_API_BASE_URL
              }/reservationdetail?vs=${vs}&pass=${pass}`}
            >
              <Button primary onClick={this.handleClickDetail}>
                {__('Zobraziť detail a stiahnuť cestovný lístok')}
              </Button>
            </ButtonLink>
          )}
        </Detail>

        {this.renderDetailTable()}

        {vs && pass && (
          <NotDeliveredMail>
            <NewMain>
              <NewMailText>
                {__('Zaslať informáciu emailom známemu')}
              </NewMailText>
              <WrapperMail>
                <InputWrapper>
                  <StyledInput
                    placeholder="@"
                    value={this.state.mail}
                    onChange={this.handleChangeInput}
                    name="mail"
                  />
                </InputWrapper>
                <div>
                  {mailIsSending ? (
                    __('Odosielam ...')
                  ) : (
                    <Button primary onClick={this.handleClickMailSend}>
                      {__('Odoslať')}
                    </Button>
                  )}
                </div>
              </WrapperMail>
            </NewMain>
          </NotDeliveredMail>
        )}

        <br />

        <ButtonLink
          href={`${process.env.REACT_APP_API_BASE_URL}/${locale.lang}`}
        >
          <Button primary>{__('Naspäť na hlavnú stránku')}</Button>
        </ButtonLink>

        <br />
        <br />
      </Wrapper>
    );
  }
}

ThanksPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    query: PropTypes.shape({
      vs: PropTypes.string.isRequired,
      pass: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  otherContent: PropTypes.string.isRequired,
  otherContentName: PropTypes.string.isRequired,
  otherContentIsFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  otherContentName: otherContentNameSelector('RESERVATION_PAYMENT_OK')(state),
  otherContent: otherContentContentSelector('RESERVATION_PAYMENT_OK')(state),
  otherContentIsFetching: otherContentIsFetchingSelector(
    'RESERVATION_PAYMENT_OK',
  )(state),
});

export default connect(mapStateToProps)(ThanksPage);



// WEBPACK FOOTER //
// ./src/containers/Payment/Ok.js